import ForeignUniversitiesCreationPage from "./ForeignUniversitiesCreationPage";

export default ForeignUniversitiesCreationPage